import {get} from 'lodash';
import gql from 'graphql-tag';
import {useQuery} from '@apollo/react-hooks';
import {setItem, MAB_PAYLOAD_ITEM} from '../../utils/sessionStorage';
import {
    SERP_AMENITIES_CAROUSEL,
    SERP_PREVIOUSLY_VIEWED_CAROUSEL
} from '../../components/LeadCarouselContainer';

const mabQuery = gql`
    query(
        $componentsReady: [MabComponentType]!
        $campaignFeature: CampaignFeature!
        $clientContext: SerpContext
    ) {
        judgeSerp(
            componentsReady: $componentsReady
            campaignFeature: $campaignFeature
            clientContext: $clientContext
        ) {
            result {
                component
                level
            }
            multiArmEventPayload {
                armId
                banditId
                campaignId
                context
                payloadId
            }
        }
    }
`;

export const storeSessionPayload = (data) => {
    if (data && data.judgeSerp && data.judgeSerp.multiArmEventPayload) {
        setItem(
            MAB_PAYLOAD_ITEM,
            JSON.stringify(data.judgeSerp.multiArmEventPayload)
        );
    }
};

export const useFetchJudgeSerpData = ({
    resultCount,
    isDatedSearch,
    deviceType,
    showRecentlyViewedCarousel = true,
    showAmenityCarousel = true,
    numFilters,
    percentBooked,
    adultsCount,
    childrenCount,
    carouselRequestsAreFinished = false
}) => {
    const componentsReady = [];
    if (showRecentlyViewedCarousel) {
        componentsReady.push(SERP_PREVIOUSLY_VIEWED_CAROUSEL);
    }

    if (showAmenityCarousel) {
        componentsReady.push(SERP_AMENITIES_CAROUSEL);
    }

    const {data} = useQuery(mabQuery, {
        skip:
            !resultCount ||
            !componentsReady.length ||
            !carouselRequestsAreFinished,
        variables: {
            componentsReady,
            campaignFeature: 'SERP_LEAD_COMPONENT',
            clientContext: {
                isDatedSearch,
                resultsSize: resultCount,
                deviceType,
                filterApplied: !!numFilters,
                percentBooked:
                    percentBooked && percentBooked.currentPercentBooked
                        ? percentBooked.currentPercentBooked
                        : 0,
                adults: adultsCount,
                children: childrenCount
            }
        },
        onCompleted: storeSessionPayload
    });

    return get(data, ['judgeSerp'], {});
};
